"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuturesDenomOverride = void 0;
exports.FuturesDenomOverride = {
    WBTC: 'BTC',
    USDC: 'USD',
    iusd: 'USD',
};
